export const heroSlides = [
  {
    id: "yan-zhi-ji-yuan",
    title: "焰之纪元 第二季定档",
    summary:
      "焰之力量再度燃起，少年凛的征程迎来全新篇章。全新PV公开，新角色首度亮相，本季最不容错过的热血大作。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20anime%20key%20visual%20of%20a%20young%20fire%20warrior%20with%20blazing%20sword%20standing%20in%20a%20dramatic%20burning%20battlefield%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20orange%20and%20red%20flames%20swirling%2C%20cinematic%20lighting%2C%20wide%20panoramic%20composition%2C%20high%20quality%20anime%20promotional%20art&width=1920&height=1080&seq=wolf-hero-01&orientation=landscape",
    tag: "新番资讯",
    link: "/news/detail/yan-zhi-jiyuan-season2",
  },
  {
    id: "ling-ren-qian-ji",
    title: "灵刃千机 海外播放破亿",
    summary:
      "水墨与刀光交织的国漫巅峰之作，海外累计播放量正式突破一亿，成为国产动画出海的耀眼代表。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20chinese%20donghua%20key%20visual%20of%20a%20swordsman%20with%20a%20glowing%20spirit%20blade%20amid%20flowing%20ink%20clouds%20and%20misty%20mountains%2C%20vibrant%20cel-shaded%20art%20style%2C%20red%20and%20gold%20cinematic%20lighting%2C%20wide%20panoramic%20composition%2C%20high%20quality%20donghua%20promotional%20art&width=1920&height=1080&seq=wolf-hero-02&orientation=landscape",
    tag: "行业动态",
    link: "/news/detail/ling-ren-qian-ji-overseas",
  },
  {
    id: "shen-hai-hui-xiang",
    title: "深海回响 年度最佳提名",
    summary:
      "被大海包裹的沉浸体验，本季最大黑马《深海回响》入围年度最佳剧情动画，悬疑与美学并存。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20anime%20key%20visual%20of%20a%20diver%20descending%20into%20glowing%20deep%20sea%20ruins%20with%20bioluminescent%20light%20rays%2C%20vibrant%20cel-shaded%20anime%20art%20style%2C%20mysterious%20deep%20blue%20atmosphere%2C%20wide%20panoramic%20composition%2C%20high%20quality%20anime%20promotional%20art&width=1920&height=1080&seq=wolf-hero-03&orientation=landscape",
    tag: "作品动态",
    link: "/news/detail/shen-hai-hui-xiang-award",
  },
];